import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, ControlLabel } from 'react-bootstrap'
import { Row, Col } from 'react-flexbox-grid'

import { mapToSelectArray } from 'Shared/helpers'
import { GlgSelect } from 'SharedComponents'

class TourFilter extends Component {
  constructor(props) {
    super(props)
    this.onChange = props.onChange.bind(this, 'tour')
  }

  shouldComponentUpdate(nextProps) {
    // The content of the tours doesn't change, so it's enough to check the count
    return this.props.toursOptions.length !== nextProps.toursOptions.length ||
           this.props.value !== nextProps.value
  }

  render() {
    const toursSelectOptions = mapToSelectArray(this.props.toursOptions, { changeNone: false })
    const tourText = (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.tour_filter.tour'))
    return <FormGroup><Row><Col xs={true}><ControlLabel className="add-margin-top-5">{tourText}</ControlLabel></Col></Row><Row><Col xs={true}><GlgSelect items={ toursSelectOptions } value={ this.props.value } onChange={ this.onChange } isCustomized={ this.props.isCustomized }></GlgSelect></Col></Row></FormGroup>
  }
}

TourFilter.propTypes = {
  toursOptions: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isCustomized: PropTypes.bool,
}

export default TourFilter
